import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { indexOf } from 'lodash';
import { EventsState } from '@sphere/platform';
import { Store } from '@ngrx/store';
import { SphereNotification } from '@sphere/platform';
import { UINotificationActions } from '@sphere/platform';

export const servicesUnavailableInterceptor: HttpInterceptorFn = (req, next) => {
    const store = inject(Store<EventsState>);
    const statusCodes = [500, 502, 503, 504];
    return next(req).pipe(
        catchError(error => {
            if (error instanceof HttpErrorResponse) {
                if (indexOf(statusCodes, error.status) >= 0) {
                    if (error.status !== 503) {
                        const errorNotification: SphereNotification = {
                            id: Date.now().toString(),
                            title: `Server error`,
                            content: `Service call has encountered an issue. Please try again later.`,
                            context: 'error',
                            clientNotification: true,
                            timestamp: new Date(),
                            new: true,
                            read: false,
                            app: 'sphere',
                            visible: false
                        };
                        store.dispatch(UINotificationActions.createNotification({ notification: errorNotification }));
                    } else {
                        console.debug(`Service response returned a 503 status error.`);
                    }
                }
            }
            return throwError(error);
        })
    );
};
